import apiClient from './apiClient';

export const diagnosisService = {
  getAllDiagnoses: async (page = 1, pageSize = 10) => {
    try {
      const response = await apiClient.get(`/api/diagnosis/list`, {
        params: { page, pageSize }
      });
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch diagnoses: ' + error.message);
    }
  },

  getDiagnosisByPatient: async (patientId) => {
    try {
      const response = await apiClient.get(`/api/diagnosis/by-patient/${patientId}`);
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch patient diagnoses: ' + error.message);
    }
  },

  getDiagnosisByCreator: async (creatorId) => {
    try {
      const response = await apiClient.get(`/api/diagnosis/by-creator/${creatorId}`);
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch creator diagnoses: ' + error.message);
    }
  },

  createDiagnosis: async (diagnosisData) => {
    try {
      const response = await apiClient.post(`/api/diagnosis/Add`, diagnosisData);
      return response.data;
    } catch (error) {
      throw new Error('Failed to create diagnosis: ' + error.message);
    }
  },

  updateDiagnosis: async (id, diagnosisData) => {
    try {
      const response = await apiClient.put(`/api/diagnosis/${id}`, diagnosisData);
      return response.data;
    } catch (error) {
      throw new Error('Failed to update diagnosis: ' + error.message);
    }
  },

  deleteDiagnosis: async (id) => {
    try {
      const response = await apiClient.delete(`/api/diagnosis/${id}`);
      return response.data;
    } catch (error) {
      throw new Error('Failed to delete diagnosis: ' + error.message);
    }
  },getAllDiseaseTypes: async () => {
    try {
      const response = await apiClient.get('/api/diagnosis/diseaseTypes');
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch disease types: ' + error.message);
    }
  },

  searchDiseaseTypes: async (query) => {
    try {
      const response = await apiClient.get('/api/diagnosis/diseaseTypeSearch', {
        params: { query }
      });
      return response.data;
    } catch (error) {
      throw new Error('Failed to search disease types: ' + error.message);
    }
  }

};